<app-info-page
  [title]="project ? project.name : ''"
  [isComponentOrProject]="'PROJECT'"
  [links]="pages"
  [breadcrumbs]="breadcrumbs"
>
  <button
    style="margin-left: 8px"
    mat-flat-button
    class="btn-grey btn-edit"
    aria-label="Edit project"
    [routerLink]="['/projects/edit']"
    [queryParams]="{
      solution: solutionSpace,
      id: projectId,
      origin: origin
    }"
    ngProjectAs="buttons"
  >
    <mat-icon class="icon-wide">settings</mat-icon>
    <span class="label-wide">Edit project</span>
    <span class="label-phone">Edit</span>
  </button>
</app-info-page>
